// extracted by mini-css-extract-plugin
module.exports = {"code":"Configuration_code__1MVBq","JSONPretty":"Configuration_JSONPretty__1Oxqz","copy":"Configuration_copy__3ZdVO"};